import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "sonner";
import { Wallet as WalletIcon, Plus } from "lucide-react";

export default function Wallet() {
  const { user, refresh } = useAuth();
  const [amt, setAmt] = useState(20);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    api.get("/sessions?scope=mine").then(({ data }) => setHistory(data.slice(0, 10)));
  }, []);

  const topup = async () => {
    try {
      await api.post("/wallet/topup", { usd: Number(amt), kwh: 0 });
      toast.success(`+$${amt} added`);
      refresh();
    } catch (e) {
      toast.error("Top-up failed");
    }
  };

  return (
    <div className="p-6 lg:p-8 max-w-4xl">
      <div className="mb-6">
        <div className="bin-label">CREDITS</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Wallet</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="bin-card p-6">
          <div className="bin-label mb-2">USD BALANCE</div>
          <div className="text-5xl font-black tracking-tighter font-mono text-cyan-400">
            ${user?.credits_usd.toFixed(2)}
          </div>
          <div className="text-xs text-zinc-500 mt-2 font-mono uppercase">simulated · no real billing</div>
        </div>
        <div className="bin-card p-6">
          <div className="bin-label mb-2">KWH ENTITLEMENTS</div>
          <div className="text-5xl font-black tracking-tighter font-mono text-amber-400">
            {user?.credits_kwh.toFixed(2)}
          </div>
          <div className="text-xs text-zinc-500 mt-2 font-mono uppercase">redeemable energy tokens</div>
        </div>
      </div>

      <div className="bin-card p-6 mt-4">
        <div className="bin-label mb-3">TOP UP (SIMULATED)</div>
        <div className="flex gap-2">
          <input
            data-testid="topup-amount"
            type="number"
            value={amt}
            onChange={(e) => setAmt(e.target.value)}
            className="flex-1 bg-[#18181b] border border-zinc-800 rounded px-3 py-2 text-sm font-mono"
          />
          <button data-testid="topup-btn" onClick={topup} className="bin-btn bin-btn-primary inline-flex items-center gap-2">
            <Plus className="w-4 h-4" /> Add credits
          </button>
        </div>
        <div className="mt-3 flex gap-2 flex-wrap">
          {[10, 25, 50, 100].map((v) => (
            <button key={v} onClick={() => setAmt(v)} className="bin-btn text-xs">${v}</button>
          ))}
        </div>
      </div>

      <div className="bin-card p-6 mt-4">
        <div className="bin-label mb-3">RECENT TRANSACTIONS</div>
        <table className="w-full text-xs font-mono">
          <thead>
            <tr className="text-left text-zinc-500">
              <th className="py-2">Time</th>
              <th>Station</th>
              <th>Device</th>
              <th className="text-right">kWh</th>
              <th className="text-right">Cost</th>
            </tr>
          </thead>
          <tbody>
            {history.map((s) => (
              <tr key={s.id} className="border-t border-zinc-800">
                <td className="py-2 text-zinc-500">{new Date(s.start_time).toLocaleString()}</td>
                <td>{s.station_name}</td>
                <td>{s.device_name}</td>
                <td className="text-right">{s.energy_kwh.toFixed(3)}</td>
                <td className="text-right text-cyan-400">${s.cost_usd.toFixed(3)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
